import { Navigate } from "react-router";

import { useGetProfile } from "@/api/bale";

export function RootRedirect() {
  const { status } = useGetProfile("@me");
  if (status === "success") {
    return <Navigate to="/overview" replace />;
  } else if (status === "error") {
    return <Navigate to="/join" replace />;
  }
  return null;
}
